module.exports = __webpack_public_path__ + "odinstatic/media/Ham_menu.04090ea8.svg";